import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { MarginProps } from '../../../theme/styledProps';
import { Box } from '../Box/Box';
import { Progress } from '../Progress/Progress';
import { ProgressVariant } from '../Progress/Progress.styles';

const StyledFooter = styled.footer<{ isProgress?: boolean }>(
  ({ theme, isProgress }) => ({
    boxSizing: 'border-box',
    position: 'sticky',
    bottom: 0,
    borderColor: isProgress ? 'transparent' : theme.colors.neutral['300'],
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    background: theme.colors.bg,
    padding: isProgress ? '0 0 16px' : '16px 0',
    marginTop: 56,
    zIndex: 3,
    minHeight: 72,
  }),

  margin,
);

const FooterContent = styled(Box)<{ fullWidthChildren?: boolean }>(({ fullWidthChildren }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  margin: '0 16px',

  '@media (min-width: 864px)': {
    width: fullWidthChildren ? 'auto' : 800,
    margin: '0 auto',
  },
}));

export const Content = styled(Box)({
  minHeight: 'calc(100vh - 240px)',
});

interface Props extends MarginProps {
  progress?: number;
  fullWidthChildren?: boolean;
  maxContentWidth?: number;
  progressVariant?: ProgressVariant;
}

export const StickyFooter: React.FC<Props> = ({
  progress,
  children,
  fullWidthChildren,
  maxContentWidth,
  progressVariant,
  ...rest
}) => {
  const isProgress = progress !== undefined;

  return (
    <StyledFooter isProgress={isProgress} {...rest}>
      {progress !== undefined && <Progress value={progress} variant={progressVariant} mb="16" />}

      {!!children && (
        <FooterContent
          fullWidthChildren={fullWidthChildren}
          css={maxContentWidth ? { maxWidth: maxContentWidth } : {}}
        >
          {children}
        </FooterContent>
      )}
    </StyledFooter>
  );
};

export const StickyFooterLoading = StyledFooter;
